import * as Highcharts from 'highcharts';
import {
  CustomDashStyleOptions,
  SeriesWithGraph,
} from './chart-dash-style.types';

export function applyCustomDashStyles(chart: Highcharts.Chart): void {
  chart.series.forEach((series) => {
    const custom = series.options.custom as CustomDashStyleOptions | undefined;
    const graph = (series as SeriesWithGraph).graph;
    if (!custom || !graph) return;

    const attrs: Record<string, string> = {};
    if (custom.svgDasharray) attrs['stroke-dasharray'] = custom.svgDasharray;
    attrs['stroke-linecap'] = custom.strokeLinecap ?? 'butt';
    graph.attr(attrs);
  });
}
